import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["activeKey", "defaultActiveKey", "clsPrefix", "tabBarPosition", "className", "renderTabContent", "renderTabBar", "tabBarStyle", "extraContent", "animated", "tabIndex", "children", "hideAdd", "scrollAnimated", "inkBarAnimated", "useTransform3d", "destroyInactiveTabPane", "onTabClick", "onEdit", "onNextClick", "onPrevClick", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es7.array.includes.js";

/**
* This source code is quoted from rc-tabs.
* homepage: https://github.com/react-component/tabs
*/
import React from "react";
import KeyCode from "./KeyCode";
import TabPane from "./TabPane";
import classnames from "classnames";
import TabContent from "./TabContent";
import ScrollableInkTabBar from "./ScrollableInkTabBar";
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import Icon from '../../wui-icon/src';
import { prefix } from "../../wui-core/src/index.js";

function noop() {}

function getDefaultActiveKey(props) {
  var activeKey;
  React.Children.forEach(props.children, function (child) {
    if (child && !activeKey && !child.props.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

var Tabs = createClass({
  propTypes: {
    destroyInactiveTabPane: PropTypes.bool,
    renderTabBar: PropTypes.func.isRequired,
    renderTabContent: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    children: PropTypes.any,
    clsPrefix: PropTypes.string,
    className: PropTypes.string,
    tabBarPosition: PropTypes.string,
    style: PropTypes.object,
    tabBarStyle: PropTypes.oneOf(["simple", "fill", "primary", "trangle", "upborder", "fade", "downborder", "trapezoid", "editable-card"]),
    // activeKey: PropTypes.string,
    // defaultActiveKey: PropTypes.string,
    onTabClick: PropTypes.func,
    hideAdd: PropTypes.bool,
    onEdit: PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      clsPrefix: "".concat(prefix, "-tabs"),
      destroyInactiveTabPane: false,
      onChange: noop,
      tabBarPosition: "top",
      style: {},
      renderTabContent: function renderTabContent() {
        return /*#__PURE__*/React.createElement(TabContent, null);
      },
      renderTabBar: function renderTabBar() {
        return /*#__PURE__*/React.createElement(ScrollableInkTabBar, null);
      },
      tabBarStyle: "simple",
      animated: true,
      // activeKey: '',
      // defaultActiveKey: '',
      moreType: 'moreTabsSelect',
      onTabClick: function onTabClick() {},
      className: '',
      hideAdd: false,
      onEdit: function onEdit() {}
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var activeKey;

    if ("activeKey" in props) {
      activeKey = props.activeKey;
    } else if ("defaultActiveKey" in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    return {
      activeKey: activeKey
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ("activeKey" in nextProps && nextProps.activeKey != this.state.activeKey) {
      this.setState({
        activeKey: nextProps.activeKey
      });
    }
  },
  onTabClick: function onTabClick(activeKey) {
    this.props.onTabClick && this.props.onTabClick(activeKey);

    if (this.tabBar.props.onTabClick) {
      this.tabBar.props.onTabClick(activeKey);
    }

    this.setActiveKey(activeKey);
  },
  onNavKeyDown: function onNavKeyDown(e) {
    var eventKeyCode = e.keyCode;

    if (eventKeyCode === KeyCode.RIGHT || eventKeyCode === KeyCode.DOWN) {
      e.preventDefault();
      var nextKey = this.getNextActiveKey(true);
      this.onTabClick(nextKey);
    } else if (eventKeyCode === KeyCode.LEFT || eventKeyCode === KeyCode.UP) {
      e.preventDefault();
      var previousKey = this.getNextActiveKey(false);
      this.onTabClick(previousKey);
    }
  },
  setActiveKey: function setActiveKey(activeKey) {
    if (this.state.activeKey !== activeKey) {
      if (!("activeKey" in this.props)) {
        this.setState({
          activeKey: activeKey
        });
      }

      this.props.onChange(activeKey);
    }
  },
  getNextActiveKey: function getNextActiveKey(next) {
    var activeKey = this.state.activeKey;
    var children = [];
    React.Children.forEach(this.props.children, function (c) {
      if (c && !c.props.disabled) {
        if (next) {
          children.push(c);
        } else {
          children.unshift(c);
        }
      }
    });
    var length = children.length;
    var ret = length && children[0].key;
    children.forEach(function (child, i) {
      if (child.key === activeKey) {
        if (i === length - 1) {
          ret = children[0].key;
        } else {
          ret = children[i + 1].key;
        }
      }
    });
    return ret;
  },
  onPrevClick: function onPrevClick(e) {
    var _this$props = this.props,
        tabBarPosition = _this$props.tabBarPosition,
        onPrevClick = _this$props.onPrevClick,
        onTabScroll = _this$props.onTabScroll;

    if (['top', 'bottom'].includes(tabBarPosition)) {
      onTabScroll && onTabScroll({
        direction: 'left'
      }, e);
    } else {
      onTabScroll && onTabScroll({
        direction: 'top'
      }, e);
    }

    onPrevClick && onPrevClick(e);
  },
  onNextClick: function onNextClick(e) {
    var _this$props2 = this.props,
        tabBarPosition = _this$props2.tabBarPosition,
        onNextClick = _this$props2.onNextClick,
        onTabScroll = _this$props2.onTabScroll;

    if (['top', 'bottom'].includes(tabBarPosition)) {
      onTabScroll && onTabScroll({
        direction: 'right'
      }, e);
    } else {
      onTabScroll && onTabScroll({
        direction: 'bottom'
      }, e);
    }

    onNextClick && onNextClick(e);
  },
  createNewTab: function createNewTab(targetKey) {
    var onEdit = this.props.onEdit;

    if (onEdit) {
      onEdit(targetKey, 'add');
    }
  },
  removeTab: function removeTab(targetKey, e) {
    e.stopPropagation();

    if (!targetKey) {
      return;
    }

    var onEdit = this.props.onEdit;

    if (onEdit) {
      onEdit(targetKey, 'remove');
    }
  },
  render: function render() {
    var _classnames,
        _this = this;

    var props = this.props;

    var activeKey = props.activeKey,
        defaultActiveKey = props.defaultActiveKey,
        clsPrefix = props.clsPrefix,
        tabBarPosition = props.tabBarPosition,
        className = props.className,
        renderTabContent = props.renderTabContent,
        renderTabBar = props.renderTabBar,
        tabBarStyle = props.tabBarStyle,
        extraContent = props.extraContent,
        animated = props.animated,
        tabIndex = props.tabIndex,
        children = props.children,
        hideAdd = props.hideAdd,
        scrollAnimated = props.scrollAnimated,
        inkBarAnimated = props.inkBarAnimated,
        useTransform3d = props.useTransform3d,
        destroyInactiveTabPane = props.destroyInactiveTabPane,
        onTabClick = props.onTabClick,
        onEdit = props.onEdit,
        onNextClick = props.onNextClick,
        onPrevClick = props.onPrevClick,
        onChange = props.onChange,
        others = _objectWithoutProperties(props, _excluded);

    var cls = classnames((_classnames = {}, _defineProperty(_classnames, clsPrefix, true), _defineProperty(_classnames, "".concat(clsPrefix, "-").concat(tabBarPosition), true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, "".concat(clsPrefix, "-").concat(tabBarStyle), true), _classnames));

    var renderProps = _objectSpread(_objectSpread({}, this.props), {}, {
      children: null,
      inkBarAnimated: inkBarAnimated,
      extraContent: extraContent,
      className: cls
    });

    if (renderTabBar) {
      this.tabBar = renderTabBar(renderProps, ScrollableInkTabBar);
    } else {
      this.tabBar = /*#__PURE__*/React.createElement(ScrollableInkTabBar, renderProps);
    } // only card type tabs can be added and closed


    var childrenWithClose = [],
        tabBarExtraContent = extraContent;

    if (tabBarStyle === 'editable-card') {
      childrenWithClose = [];
      React.Children.forEach(children, function (child, index) {
        if (! /*#__PURE__*/React.isValidElement(child)) return child;
        var closable = child.props.closable;
        closable = typeof closable === 'undefined' ? true : closable;
        var closeIcon = closable ? /*#__PURE__*/React.createElement(Icon, {
          type: "uf-close",
          className: "".concat(clsPrefix, "-close-x"),
          onClick: function onClick(e) {
            return _this.removeTab(child.key, e);
          }
        }) : null;
        childrenWithClose.push( /*#__PURE__*/React.cloneElement(child, {
          tab: /*#__PURE__*/React.createElement("div", {
            className: closable ? undefined : "".concat(clsPrefix, "-tab-unclosable")
          }, child.props.tab, closeIcon),
          key: child.key || index
        }));
      }); // Add new tab handler

      if (!hideAdd) {
        tabBarExtraContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          type: "uf-plus",
          className: "".concat(clsPrefix, "-new-tab"),
          onClick: this.createNewTab
        }), extraContent);
      }
    }

    var contents = [/*#__PURE__*/React.cloneElement(this.tabBar, {
      clsPrefix: clsPrefix,
      key: "tabBar",
      onKeyDown: this.onNavKeyDown,
      tabBarPosition: tabBarPosition,
      extraContent: tabBarExtraContent,
      onTabClick: this.onTabClick,
      panels: childrenWithClose.length > 0 ? childrenWithClose : children,
      activeKey: this.state.activeKey,
      tabIndex: tabIndex,
      onPrevClick: this.onPrevClick,
      onNextClick: this.onNextClick,
      tabBarStyle: tabBarStyle,
      moreType: this.props.moreType
    }), /*#__PURE__*/React.cloneElement(renderTabContent(), {
      clsPrefix: clsPrefix,
      tabBarPosition: tabBarPosition,
      animated: animated,
      activeKey: this.state.activeKey,
      destroyInactiveTabPane: props.destroyInactiveTabPane,
      children: props.children,
      // style: { height: '100%' },
      onChange: this.setActiveKey,
      key: "tabContent"
    })];

    if (tabBarPosition === "bottom") {
      contents.reverse();
    }

    return /*#__PURE__*/React.createElement("div", _extends({
      className: cls,
      style: props.style
    }, others), contents);
  }
});
Tabs.TabPane = TabPane;
export { Tabs };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/Tabs.js